import styled from "@emotion/styled";
import { Chip } from "@mui/material";
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useTranslation } from "react-i18next";
import { AssetClass } from "@api/v1/hooks/performance/assetClasses";
import { useAssetClassFilter } from "./AssetClassFilterContext";

const FilterChip = styled(Chip)(({ theme }) => ({
  maxWidth: "100%",
  backgroundColor: theme.palette.background.selected,
  color: theme.palette.primary.main,
  fontWeight: 600,
  "& .MuiChip-icon, & .MuiChip-deleteIcon": {
    color: theme.palette.primary.main,
  },
}));

const titleKey = (assetClass: AssetClass) =>
  assetClass === "holdings" ? "allHoldings" : assetClass;

// Names the active asset classes while the page is filtered; clears them.
export const AssetClassFilterChip = () => {
  const { t } = useTranslation();
  const { activeClasses, clear } = useAssetClassFilter();

  if (!activeClasses.length) return null;

  const label = activeClasses
    .map((assetClass) => t(`assetTypeBreakdown.${titleKey(assetClass)}.title`))
    .join(" + ");

  return (
    <FilterChip
      size="small"
      icon={<FilterListRoundedIcon fontSize="small" />}
      label={label}
      onClick={clear}
      onDelete={clear}
      deleteIcon={<CloseRoundedIcon fontSize="small" />}
      aria-label={t("assetTypeBreakdown.filter.clear", { classes: label })}
      data-testid="asset-class-filter-chip"
    />
  );
};
